import {SearchCriteriaConfig} from "../../../../common/search-criteria/type/search-criteria.type";

export const searchCriteria: SearchCriteriaConfig[] = [
    {
        key: 'assignedDateRange',
        label: 'Assigned Date',
        inputType: 'date-range'
    },
    {
        key: 'expectedReturnDateRange',
        label: 'Expected Return Date',
        inputType: 'date-range'
    },
];